import { getCurrentInstance, computed } from "vue";
import { useVuelidate } from "@vuelidate/core";

/**
 * Bridges legacy `$v` usage to Vuelidate 2's `v$`.
 * Must return `$v` from setup — Vue 3 does not proxy `$`-prefixed
 * Options API computed/data onto the instance.
 *
 * If a component already calls useVuelidate() in its own setup and returns
 * `v$`, we only add a `$v` alias that points at the same ref after merge
 * by also calling useVuelidate once here when validations exist and the
 * component setup did not return `$v`. To avoid double state, components
 * that call useVuelidate themselves should return `{ v$, $v: v$ }`.
 */
export const vuelidateCompatMixin = {
  setup() {
    const instance = getCurrentInstance();
    const validations =
      instance?.type?.validations ||
      instance?.proxy?.$options?.validations;
    if (!validations) {
      return {};
    }
    const v$ = useVuelidate();
    return { v$, $v: v$ };
  }
};

export default {
  install(app) {
    app.mixin(vuelidateCompatMixin);
  }
};
